import React from 'react';

export const highlightCharacters = (
    sourceString: string,
    highlightedCharacters: {start: number; end: number}[],
    markClass?: string,
): React.ReactNode[] => {
    if (highlightedCharacters.length === 0) {
        return [sourceString];
    }

    // Sort ranges by start
    const sorted = [...highlightedCharacters].sort((a, b) => a.start - b.start);

    // Merge overlapping / touching ranges
    const merged: {start: number; end: number}[] = [];
    for (const range of sorted) {
        if (merged.length === 0) {
            merged.push({...range});
        } else {
            const last = merged[merged.length - 1];
            if (last && range.start <= last.end + 1) {
                // Overlapping or adjacent, merge
                last.end = Math.max(last.end, range.end);
            } else {
                merged.push({...range});
            }
        }
    }

    // Build React nodes
    let lastIndex = 0;
    const parts: React.ReactNode[] = [];

    for (let i = 0; i < merged.length; i++) {
        const range = merged[i];
        if (!range) {
            continue;
        }
        const start = Math.max(0, Math.min(range.start, sourceString.length));
        const end = Math.max(0, Math.min(range.end, sourceString.length - 1));
        if (lastIndex < start) {
            parts.push(sourceString.slice(lastIndex, start));
        }
        const highlightedText = sourceString.slice(start, end + 1);
        const key = `${start}-${end}`;
        if (highlightedText) {
            parts.push(
                <mark className={markClass} key={key}>
                    {highlightedText}
                </mark>,
            );
        }
        lastIndex = end + 1;
    }
    if (lastIndex < sourceString.length) {
        parts.push(sourceString.slice(lastIndex));
    }

    return parts;
};
